import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'cerrix-button',
    imports: [CommonModule, MatButtonModule, MatTooltipModule],
    templateUrl: './cerrix-button.component.html',
    styleUrl: './cerrix-button.component.scss'
})
export class CerrixButtonComponent implements OnDestroy {
  @Input() public type: 'flat' | 'stroked' = 'flat';
  @Input() public size: 'small' | 'medium' | 'default' | 'large' = 'default';
  @Input() public disabled: boolean = false;
  @Input() public isCallToAction: boolean = false;
  @Input() public dataUiid: string = "undefined"
  @Input() public color:
    | 'primary'
    | 'primary-light'
    | 'success'
    | 'warn'
    | 'error'
    | 'error-light'
    | 'accent'
    | 'accent-light' = 'primary';
  @Input() public tooltipContent: string | undefined = undefined;

  @ViewChild('buttonElement', { static: false }) public button!: MatButton;
  @ViewChild('contentTemplate', { static: false })
  public buttonContent!: TemplateRef<any>;

  @HostBinding('class.disabled') public get hasClassDisabled(): boolean {
    return this.disabled;
  }

  private elementRef = inject(ElementRef);

  constructor() {
    this.elementRef.nativeElement.addEventListener(
      'click',
      this.haltDisabledEvents
    );
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener(
      'click',
      this.haltDisabledEvents
    );
  }

  haltDisabledEvents = (event: Event): void => {
    if (this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
  };
}
